import {
  useCurrentAccount,
  useCurrentProject,
  useCurrentProjectId,
} from '@adsk/alloy-provider';
import { useLocale } from '@adsk/alloy-react-locale';

import { PRODUCTS } from './consts';
import getAccountServices from './helpers/getAccountServices';

const useProducts = () => {
  const { T } = useLocale(({ locale }) => require(`./i18n/${locale}.json`));
  const currentProject = useCurrentProject();
  const currentAccount = useCurrentAccount();
  const currentProjectId = useCurrentProjectId();
  const currentAccountServices = currentProjectId
    ? undefined
    : getAccountServices(currentAccount);

  if (currentProjectId) {
    const nonAdminProducts =
      currentProject?.products.filter(
        (product) => product.category !== 'admin',
      ) || [];
    const adminProducts =
      currentProject?.products.filter(
        (product) => product.category === 'admin',
      ) || [];

    return [...nonAdminProducts, ...adminProducts]; // admin products should be last
  }
  if (!currentAccountServices) return [];

  const products = PRODUCTS.filter((product) =>
    currentAccountServices.some(
      (service) => service.serviceType === product.serviceType,
    ),
  );

  return products.map((product) => {
    const currentService = currentAccountServices.find(
      (service) => service.serviceType === product.serviceType,
    );
    const url = currentService.accountUrl;

    return {
      ...product,
      name: T.translate(product.nameTranslationKey),
      key: product.id,
      defaultUrl: url,
      url,
    };
  });
};

export { useProducts };
